import React from 'react';
import star_empty from '../../../../assets/Main/star_empty.svg';
import star_filled from '../../../../assets/Main/star_filled.svg';

const Stars = ({ value, setValue }) => (
  <div style={{ display: 'flex', gap: '5px' }}>
    {[1, 2, 3, 4, 5].map((starItem) => (
      <img
        key={starItem}
        src={starItem <= value ? star_filled : star_empty}
        alt=""
        onClick={() => setValue(starItem)}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
      />
    ))}
  </div>
);

export default Stars;